module.exports = __webpack_public_path__ + "static/media/25_plantilla_combo_rectangular_marco_comida_70.7501405b.png";